const stripTrailingSlash = (value) => String(value || '').trim().replace(/\/$/, '');

export const getMeetingSocketBaseUrl = () => {
  const runtime = typeof window !== 'undefined'
    ? stripTrailingSlash(window.__SHEPHERDS_SOCKET_URL__)
    : '';
  const configured = typeof process !== 'undefined'
    ? stripTrailingSlash(process.env.REACT_APP_SOCKET_URL)
    : '';
  const value = runtime || configured || 'https://api.shepherdsindia.sbs';

  if (!/^https?:\/\//i.test(value)) return `https://${value}`;
  return value;
};

export default getMeetingSocketBaseUrl;

